import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/index.scss'
// import animated from 'animate.css'
import 'wowjs/css/libs/animate.css'

// Vue.use(animated)

Vue.config.productionTip = false

// import VueAwesomeSwiper from 'vue-awesome-swiper';
// import 'swiper/dist/css/swiper.css';
// Vue.use(VueAwesomeSwiper);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')